// lazyload config
var MODULE_CONFIG = {
    easyPieChart:   [ '../libs/jquery/jquery.easy-pie-chart/dist/jquery.easypiechart.fill.js' ],
    sparkline:      [ '../libs/jquery/jquery.sparkline/dist/jquery.sparkline.retina.js' ],
    plot:           [ '../libs/jquery/flot/jquery.flot.js',
                      '../libs/jquery/flot/jquery.flot.resize.js',
                      '../libs/jquery/flot/jquery.flot.pie.js',
                      '../libs/jquery/flot.tooltip/js/jquery.flot.tooltip.min.js',
                      '../libs/jquery/flot-spline/js/jquery.flot.spline.min.js',
                      '../libs/jquery/flot.orderbars/js/jquery.flot.orderBars.js'],
    vectorMap:      [ '../libs/jquery/bower-jvectormap/jquery-jvectormap-1.2.2.min.js',
                      '../libs/jquery/bower-jvectormap/jquery-jvectormap.css', 
                      '../libs/jquery/bower-jvectormap/jquery-jvectormap-world-mill-en.js',
                      '../libs/jquery/bower-jvectormap/jquery-jvectormap-us-aea-en.js' ],
    dataTable:      [
                      '../libs/jquery/datatables/media/js/jquery.dataTables.min.js',
                      '../libs/jquery/plugins/integration/bootstrap/3/dataTables.bootstrap.js',
                      '../libs/jquery/plugins/integration/bootstrap/3/dataTables.bootstrap.css'],
    footable:       [
                      '../libs/jquery/footable/dist/footable.all.min.js',
                      '../libs/jquery/footable/css/footable.core.css'
                    ],
    screenfull:     [
                      '../libs/jquery/screenfull/dist/screenfull.min.js'
                    ],
    sortable:       [
                      '../libs/jquery/html.sortable/dist/html.sortable.min.js'
                    ],
    nestable:       [
                      '../libs/jquery/nestable/jquery.nestable.css',
                      '../libs/jquery/nestable/jquery.nestable.js'
                    ],
    summernote:     [
                      '../libs/jquery/summernote/dist/summernote.css',
                      '../libs/jquery/summernote/dist/summernote.js'
                    ],
    parsley:        [
                      '../libs/jquery/parsleyjs/dist/parsley.css',
                      '../libs/jquery/parsleyjs/dist/parsley.min.js'
                    ],
    select2:        [
                      '../libs/jquery/select2/dist/css/select2.min.css',
                      '../libs/jquery/select2-bootstrap-theme/dist/select2-bootstrap.min.css',
                      '../libs/jquery/select2-bootstrap-theme/dist/select2-bootstrap.4.css',
                      '../libs/jquery/select2/dist/js/select2.min.js'
                    ],
    datetimepicker: [
                      '../libs/jquery/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css',
                      '../libs/jquery/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.dark.css',
                      '../libs/js/moment/moment.js',
                      '../libs/jquery/eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js'
                    ],
    chart:          [
                      '../libs/js/echarts/build/dist/echarts-all.js',
                      '../libs/js/echarts/build/dist/theme.js',
                      '../libs/js/echarts/build/dist/jquery.echarts.js'
                    ],
    bootstrapWizard:[
                      '../libs/jquery/twitter-bootstrap-wizard/jquery.bootstrap.wizard.min.js'
                    ],
    fullCalendar:   [
                      '../libs/jquery/moment/moment.js',
                      '../libs/jquery/fullcalendar/dist/fullcalendar.min.js',
                      '../libs/jquery/fullcalendar/dist/fullcalendar.css',
                      '../libs/jquery/fullcalendar/dist/fullcalendar.theme.css',
                      'scripts/plugins/calendar.js'
                    ],
    dropzone:       [
                      '../libs/js/dropzone/dist/min/dropzone.min.js',
                      '../libs/js/dropzone/dist/min/dropzone.min.css'
                    ]
  };
